<activar-modal [visible]="isVisible()" [closable]="false">
  <div class="flex-col mx-auto p-5 text-center" style="width: 400px">
    <h2>Operar como un productor</h2>
    <app-search-users
      (userSelected)="setUser($event)"
      userTypes=""
      userRoles="AGENT"
    />

    <div class="flex mt-7 items-center justify-center gap-5">
      <activar-button
        text="Cancelar"
        fill="out"
        expand="full"
        (click)="cancel()"
      />

      <activar-button
        text="Seleccionar"
        fill="solid"
        expand="full"
        (click)="selectUser()"
      />
    </div>
  </div>
</activar-modal>
